<div class="community">
  <!-- <iframe frameBorder="0" src="https://kind-hill-000f26403-1.westeurope.3.azurestaticapps.net/#/login"></iframe> -->
  <h1>Welcome to the 7N community</h1>
  <p class="body2">The beta version of the 7N community is now available to all existing consultants of 7N. We
    will, over the next 6 month, integrate it into the platform and add additional features. For now you will have to
    click the button below and open the community in a new tab. Have bugs, ideas or feedback - please let us know. </p>
  <app-button (click)="open()" [class]="['primary']" [label]="'Open community'"></app-button>
</div>
